import { useState } from 'react';
import { useWizardStore } from '../../store/wizard.js';
import { Sheet } from '../common/Sheet.js';
import { GraphPanel } from './GraphPanel.js';

/**
 * Mobile candidate summary: a horizontal strip of the top species (by
 * probability) from the server-provided candidate list. Tapping expands the
 * full candidate graph in a sheet.
 */
export function CandidateStrip(): JSX.Element | null {
  const candidates = useWizardStore(s => s.candidates);
  const [expanded, setExpanded] = useState(false);

  if (candidates.length === 0) return null;
  const top = [...candidates]
    .filter(c => c.probability > 0.001)
    .sort((a, b) => b.probability - a.probability)
    .slice(0, 8);
  if (top.length === 0) return null;

  return (
    <>
      <button
        onClick={() => setExpanded(true)}
        className="w-full overflow-x-auto border-b border-bark-300/40 bg-paper-100 p-2 text-left"
        aria-label="Tap to expand the full candidates graph"
      >
        <div className="flex gap-2">
          {top.map(c => (
            <div key={c.speciesId} className="flex shrink-0 flex-col items-center rounded-md bg-paper-50 p-2 shadow-paper">
              <div className="h-12 w-12 rounded-full bg-sage-300" style={{ opacity: Math.max(0.2, c.probability) }} />
              <p className="mt-1 max-w-[80px] truncate font-body text-xs text-ink-900">
                {c.commonNames?.[0] ?? c.scientificName}
              </p>
              <p className="font-mono text-[10px] text-bark-500">{Math.round(c.probability * 100)}%</p>
            </div>
          ))}
        </div>
      </button>
      <Sheet open={expanded} onClose={() => setExpanded(false)} title="All candidates">
        <div className="h-[60vh]"><GraphPanel /></div>
      </Sheet>
    </>
  );
}
